// extracted by mini-css-extract-plugin
export var compactFilters = "_gc-4";
export var detailImage = "_gc-1";
export var dropdownContainer = "_gc-2";
export var imageContainer = "_gc-0";
export var selectedCard = "_gc-3";